import { render, staticRenderFns } from "./TrainOfVideo.vue?vue&type=template&id=b047ee1c"
import script from "./TrainOfVideo.vue?vue&type=script&lang=js"
export * from "./TrainOfVideo.vue?vue&type=script&lang=js"
import style0 from "./TrainOfVideo.vue?vue&type=style&index=0&id=b047ee1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports